import { Localized } from "@fluent/react/compat";
import cn from "classnames";
import { BaseButton } from "coral-ui/components/v2";
import React, { FunctionComponent } from "react";
import styles from "./FeatureButton.css";

interface Props {
  enabled?: boolean;
  className?: string;
  featured?: boolean;
  qaTagged?: boolean;
  title?: string;
  enableQaFlag?: boolean;
  onClick?: () => void;
}

const TagButton: FunctionComponent<Props> = ({
  enabled = true,
  className,
  featured = false,
  qaTagged = false,
  enableQaFlag = false,
  ...rest
}) => (
  <BaseButton
    {...rest}
    className={cn(className, styles.root, {
      [styles.invert]: featured || qaTagged,
    })}
    disabled={!enabled}
  >
    {featured || qaTagged ? (
      <Localized id="moderate-comment-manageTags">
        {featured ? <span>Featured</span> : <span>Q&A</span>}
      </Localized>
    ) : enableQaFlag ? (
      <Localized id="moderate-comment-addTag">
        <span>Pin Comment</span>
      </Localized>
    ) : (
      <Localized id="moderate-comment-featureText">
        <span>Feature</span>
      </Localized>
    )}
  </BaseButton>
);

export default TagButton;
